import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import clamp from 'lodash/clamp';
import isEqual from 'lodash/isEqual';

import { show, hide } from 'store/modules/dialog/actions';

import { Footer, Main, Header } from 'components/ClosedCaption';
import Sub from 'utils/subtitle/sub';
import { secondToTime, notify } from 'utils';
import { vttToUrlUseWorker } from 'utils/subtitle';
import Storage from 'utils/storage';
import api from 'services/api';

import { Container } from './styles';
import demovideo from 'assets/video_demo.mp4';
const history = [];
const storage = new Storage();
const worker = new Worker(vttToUrlUseWorker());

export default function() {
  // Get midiaID
  const { midiaId, type } = useParams();
  // loading
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingFinish, setLoadingFinish] = useState(false);
  // react-router-dom
  const navigate = useNavigate();
  // redux
  const dispatch = useDispatch();
  // Player instance
  const [player, setPlayer] = useState(null);

  // Subtitle currently playing index
  const [currentIndex, setCurrentIndex] = useState(-1);

  // Subtitle currently playing time
  const [currentTime, setCurrentTime] = useState(0);

  // All subtitles
  const [subtitles, setSubtitles] = useState([]);

  // Redux
  const { callback: callbackDialog } = useSelector(state => state.dialog);

  // All options
  const [options, setOptions] = useState({
    videoUrl: demovideo,
    subtitleUrl: '/sample.vtt',
    uploadDialog: false,
    importDialog: false,
  });

  // Update an option
  const setOption = useCallback(
    option => {
      setOptions({
        ...options,
        ...option,
      });
    },
    [options, setOptions],
  );

  // Only way to update all subtitles
  const updateSubtitles = useCallback(
    (subs, saveToHistory = true) => {
      if (subs.length && !isEqual(subs, subtitles)) {
        const ordenedSubs = subs.sort((a, b) =>
          a.start > b.start ? 1 : b.start > a.start ? -1 : 0,
        );

        setSubtitles(ordenedSubs);

        // Save 100 subtitles to history
        if (saveToHistory) {
          if (history.length >= 100) {
            history.shift();
          }
          history.push(ordenedSubs.map(sub => sub.clone));
        }

        // Save to storage
        storage.set('subtitles', ordenedSubs);

        // Convert subtitles to vtt url
        worker.postMessage(ordenedSubs);
      }
    },
    [setSubtitles, subtitles],
  );

  // Copy all subtitles
  const copySubtitles = useCallback(() => subtitles.map(sub => sub.clone), [
    subtitles,
  ]);

  // Add a subtitle
  const addSubtitle = useCallback(
    (index, sub) => {
      const subs = copySubtitles();
      console.log('sub', sub);
      console.log('index', index);
      console.log('currentIndex', index);
      if (sub) {
        console.log('if');
        subs.splice(index, 0, sub);
      } else {
        console.log('else');
        const previous = subs[index - 1];
        const start = previous
          ? secondToTime(previous.endTime + 0.1)
          : '00:00:00.001';
        const end = previous
          ? secondToTime(previous.endTime + 1.1)
          : '00:00:01.001';
        const sub = new Sub(start, end, '[Subtitle Text]');
        subs.splice(index, 0, sub);
      }
      updateSubtitles(subs);
    },
    [copySubtitles, updateSubtitles],
  );

  const init = useCallback(async () => {
    if (midiaId) {
      try {
        dispatch(
          show({
            showLoading: true,
            showCancelButton: false,
            title: 'Buscando legenda...',
            allowOutsideClick: false,
          }),
        );
        // busca chamado
        // setArquivo(response.data.chamada)
        // Falta verificar se existe arquivo de midia...

        // busca Legendas
        const responseleg = await api.get(`/legendas/${midiaId}`);

        const temLegendas = !!responseleg.data && responseleg.data.length > 0;
        if (temLegendas) {
          const legendas = responseleg.data.map(legenda => {
            const start = legenda.starttime.replace(',', '.');
            const end = legenda.endtime.replace(',', '.');
            const text = `${legenda.linha1 ? legenda.linha1 : ' '} \n ${
              legenda.linha2 ? legenda.linha2 : ' '
            }`;

            return new Sub(start, end, text, false);
          });

          updateSubtitles(legendas);
        } else {
          addSubtitle();
          notify('legenda não encontrada', 'error');
        }

        const response = await api.get(`/midias/${midiaId}`);
        if (response && response.data && response.data.pendente) {
          // console.log('preview' + response.data.pendente.preview_url)
          var videoUrl;
          if (type) {
            videoUrl = response.data.pendente.preview_url;
          } else {
            const blob = await fetch(
              response.data.pendente.preview_url,
            ).then(r => r.blob());

            videoUrl = window.URL
              ? window.URL.createObjectURL(blob)
              : window.webkitURL.createObjectURL(blob);
          }

          setOption({
            ...options,
            videoUrl,
          });
          setLoading(false);
          dispatch(hide());
        } else toast.error('Falha de comunicação com o sistema');
      } catch (err) {
        console.log(err);
        if (err) {
          setLoadingSubmit(false);
          switch (err.status) {
            case 406: // notAcceptable
              dispatch(
                show({
                  type: 'error',
                  text: err.message || 'Erro inesperado',
                  showCancelButton: true,
                  showConfirmButton: false,
                  showCloseButton: false,
                  cancelButtonText: 'VOLTAR',
                  allowOutsideClick: false,
                  callback: { onClose: () => navigate(-1) },
                }),
              );
              break;
            case 428: // precoditionRequired
              dispatch(
                show({
                  type: 'question',
                  text: err.message,
                  confirmButtonText: 'CONFIRMAR',
                  callback: {
                    url: `/midias/${midiaId}`,
                    method: api.put,
                    data: { statuscaption: 'edicao' },
                    onClose: () => navigate(-1),
                  },
                  haveCallback: true,
                  successMessage: 'OK! Liberando editor para edição manual!',
                  cancelButtonText: 'VOLTAR PARA TELA ANTERIOR',
                  allowOutsideClick: false,
                  showCancelButton: true,
                  showConfirmButton: true,
                  showCloseButton: false,
                }),
              );
              break;
            default:
              notify(err.message, 'error');
              break;
          }
        } else {
          dispatch(hide());
          // console.log(err.message);
          // alert(err.message);
          notify(err.message, 'error');
        }
      }
    } else {
      dispatch(
        show({
          type: 'info',
          text:
            'Para iniciar a legenda de um novo arquivo .mp4 clique em carregar',
        }),
      );
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Initialize subtitles from url or storage
  /* const initSubtitles = useCallback(async () => {
    const storageSubs = storage.get('subtitles')
    if (storageSubs && storageSubs.length) {
      updateSubtitles(
        storageSubs.map(item => new Sub(item.start, item.end, item.text))
      )
    } else {
      const subs = await getSubFromVttUrl(options.subtitleUrl)
      updateSubtitles(subs)
    }
  }, [options.subtitleUrl, updateSubtitles]) */

  // CALLBACK DIALOG
  useEffect(() => {
    if (callbackDialog && callbackDialog.success)
      if (callbackDialog.success.action === 'success') {
        setTimeout(() => {
          init();

          if (player && !worker.onmessage) {
            worker.onmessage = event => {
              player.subtitle.switch(event.data);
            };
          }
        }, 2000);
      }
  }, [callbackDialog, init, player]);

  // function load on page is open
  useEffect(() => {
    // initSubtitles()
    init();
    if (player && !worker.onmessage) {
      worker.onmessage = event => {
        player.subtitle.switch(event.data);
      };
    }
  }, [init, player]);

  // Update current index from current time
  useMemo(() => {
    // console.log(currentTime)
    setCurrentIndex(
      subtitles.findIndex(
        item => item.startTime <= currentTime && item.endTime > currentTime,
      ),
    );
  }, [subtitles, currentTime, setCurrentIndex]);

  // Detect if the subtitle exists
  const hasSubtitle = useCallback(sub => subtitles.indexOf(sub), [subtitles]);

  // Update a single subtitle
  const updateSubtitle = useCallback(
    (sub, key, value) => {
      const index = hasSubtitle(sub);
      if (index < 0) return;
      const subs = copySubtitles();
      const { clone } = sub;
      if (typeof key === 'object') {
        Object.assign(clone, key);
      } else {
        clone[key] = value;
      }
      if (clone.check) {
        subs[index] = clone;
        updateSubtitles(subs);
      } else {
        notify('Erro de parâmetro', 'error');
      }
    },
    [hasSubtitle, copySubtitles, updateSubtitles],
  );

  // Check if subtitle is legal
  const checkSubtitle = useCallback(
    sub => {
      const index = hasSubtitle(sub);

      if (index < 0) return;
      const previous = subtitles[index - 1];

      if (previous && sub.startTime < previous.endTime) {
        updateSubtitle(sub, 'warn', true);
        return true;
      }

      if (sub.warn) {
        updateSubtitle(sub, 'warn', false);
      }
      return !sub.check;
      // return (previous && sub.startTime < previous.endTime) || !sub.check
      // // return (previous && sub.startTime < previous.endTime) || !sub.check
    },
    [hasSubtitle, subtitles, updateSubtitle],
  );

  // Delete a subtitle
  const removeSubtitle = useCallback(
    sub => {
      const index = hasSubtitle(sub);
      if (index < 0) return;
      const subs = copySubtitles();
      if (subs.length === 1) {
        return notify(' Por favor, mantenha pelo menos uma legenda', 'error');
      }
      subs.splice(index, 1);
      updateSubtitles(subs);
    },
    [hasSubtitle, copySubtitles, updateSubtitles],
  );

  // Merge two subtitles
  const mergeSubtitle = useCallback(
    sub => {
      const index = hasSubtitle(sub);
      if (index < 0) return;
      const subs = copySubtitles();
      const next = subs[index + 1];
      if (!hasSubtitle(next)) return;
      const merge = new Sub(sub.start, next.end, sub.text + '\n' + next.text);
      subs[index] = merge;
      subs.splice(index + 1, 1);
      updateSubtitles(subs);
    },
    [hasSubtitle, copySubtitles, updateSubtitles],
  );

  // Remove all subtitles
  const removeSubtitles = useCallback(() => {
    updateSubtitles([
      new Sub('00:00:00.000', '00:00:01.000', '[Subtitle Text]'),
    ]);
  }, [updateSubtitles]);

  // Undo subtitles
  const undoSubtitles = useCallback(() => {
    if (history.length > 1) {
      history.pop();
      const subs = history[history.length - 1];
      updateSubtitles(subs, false);
      notify('Reversão do histórico bem-sucedida');
    } else {
      notify('O histórico está vazio', 'error');
    }
  }, [updateSubtitles]);

  // Subtitle time offset
  const timeOffsetSubtitles = useCallback(
    (time, side) => {
      const subs = copySubtitles();
      updateSubtitles(
        subs.map(item => {
          if (side === 'right' && subs.indexOf(item) > currentIndex) {
            item.start = secondToTime(
              clamp(item.startTime + time, 0, Infinity),
            );
            item.end = secondToTime(clamp(item.endTime + time, 0, Infinity));
          } else if (side === 'left' && subs.indexOf(item) < currentIndex) {
            item.start = secondToTime(
              clamp(item.startTime + time, 0, Infinity),
            );
            item.end = secondToTime(clamp(item.endTime + time, 0, Infinity));
          } else if (side === 'all') {
            item.start = secondToTime(
              clamp(item.startTime + time, 0, Infinity),
            );
            item.end = secondToTime(clamp(item.endTime + time, 0, Infinity));
          }
          return item;
        }),
      );
      notify(`${'Time Offset'} ${time * 1000}ms`);
    },
    [copySubtitles, currentIndex, updateSubtitles],
  );

  // Clean all subtitles
  const cleanSubtitles = useCallback(() => {
    history.length = 0;
    storage.set('subtitles', []);
    removeSubtitles();
    player.seek = 0;
    notify('Lengendas removidas');
  }, [player, removeSubtitles]);

  const saveSubtitle = useCallback(
    async popMsg => {
      let legendas = [];
      setLoadingSubmit(true);

      if (!subtitles && !!subtitles.length === 0) {
        notify('Sem legendas para salvar');
      }

      const hasWarn = subtitles.find(leg => leg.warn === true);

      if (hasWarn) {
        // show({
        //   type: 'error',
        //   showCancelButton: true,
        //   title: 'ERROR',
        //   allowOutsideClick: true,
        // })
        if (popMsg)
          dispatch(
            show({
              type: 'warning',
              text: 'Legendas sobrepostas, verifique a posiçao das linhas',
              allowOutsideClick: true,
            }),
          );
        setLoadingSubmit(false);
        return;
      }

      try {
        legendas = subtitles.map((sub, index) => {
          const [linha1, linha2] = sub.text.split('\n');
          return {
            sequencia: index + 1,
            starttime: sub.start.replace('.', ','),
            endtime: sub.end.replace('.', ','),
            intervalo: sub.duration,
            linha1,
            linha2,
          };
        });
        await api
          .put(`/legendas/${midiaId}`, legendas)
          .then(response => {
            if (response && popMsg)
              dispatch(show({ type: 'success', text: 'Legendas atualizadas' }));
            else if (popMsg)
              dispatch(
                show({ type: 'error', text: 'Falha ao salvar legendas' }),
              );
          })
          .catch(error => {
            if (error instanceof Error) toast.error(error.message);
            else toast.error('Erro inesperado');
          });

        setLoadingSubmit(false);
      } catch (err) {
        if (err) {
          setLoadingSubmit(false);
          switch (err.status) {
            case 406:
              dispatch(
                show({
                  type: 'error',
                  text: err.message || 'Erro inesperado',
                }),
              );
              break;

            default:
              notify(err.message, 'error');
              break;
          }
        } else {
          notify(err.message, 'error');
        }
        // if (err.response === 406) {
        //   dispatch(show({ type: 'error', text: err }))
        // }
      }
      // '/legendas/:chamadaId',
      // CORRIGIR ESSE ERRO!!!! ESTA LIMPANDO AS LEGENDAS
    },
    [dispatch, midiaId, subtitles],
  );

  // Auto-save de CC
  useEffect(() => {
    const interval = setInterval(() => {
      saveSubtitle(false);
    }, 60000);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [saveSubtitle]);

  const finishSubtitle = useCallback(async () => {
    setLoadingFinish(true);
    try {
      let legendas = [];
      legendas = subtitles.map((sub, index) => {
        const [linha1, linha2] = sub.text.split('\n');
        return {
          sequencia: index + 1,
          starttime: sub.start.replace('.', ','),
          endtime: sub.end.replace('.', ','),
          intervalo: sub.duration,
          linha1,
          linha2,
        };
      });
      await api
        .put(`/legendas/${midiaId}`, legendas)
        .then(response => {
          if (response) {
            api.put(`/midias/${midiaId}`, {
              statuscaption: 'editada',
            });
            const option = {
              type: 'success',
              confirmButtonText: '',
              timer: 3000,
              cancelButtonText: 'NÃO',
              showCancelButton: false,
              showConfirmButton: false,
              showCloseButton: true,
              text:
                'Edição de Legenda finalizada! Voltando para o kanban em 3 segundos',
              callback: { onClose: () => navigate(-1) },
            };
            dispatch(show(option));
          } else
            dispatch(show({ type: 'error', text: 'Falha ao salvar legendas' }));
        })
        .catch(error => {
          if (error instanceof Error) toast.error(error.message);
          else toast.error('Erro inesperado');
        });

      setLoadingFinish(false);
    } catch (err) {
      notify(err.message, 'error');

      setLoadingFinish(false);
    }
  }, [midiaId, dispatch, subtitles]);

  const handleImport = useCallback(
    chamada => {
      setOptions(state => ({ ...state, importDialog: false }));
      if (!!chamada && !!chamada.legendas.length > 0) {
        const legendas = chamada.legendas.map(legenda => {
          const start = legenda.starttime.replace(',', '.');
          const end = legenda.endtime.replace(',', '.');
          const text = `${
            legenda.linha1 ? legenda.linha1.replace(/\s+/g, ' ').trim() : ''
          }\n${
            legenda.linha2 ? legenda.linha2.replace(/\s+/g, ' ').trim() : ''
          }`;
          return new Sub(start, end, text);
        });

        updateSubtitles(legendas);
        notify('Legenda(s) importada.', 'info');
      } else {
        notify('Erro ao importar legenda.', 'error');
      }
    },
    [updateSubtitles],
  );

  const props = {
    player,
    options,

    subtitles,
    currentTime,
    currentIndex,

    loadingSubmit,
    loadingFinish,

    setOption,
    setPlayer,
    setCurrentTime,
    setCurrentIndex,

    hasSubtitle,
    addSubtitle,
    checkSubtitle,
    undoSubtitles,
    mergeSubtitle,
    removeSubtitle,
    saveSubtitle,
    finishSubtitle,
    updateSubtitle,
    cleanSubtitles,
    updateSubtitles,
    removeSubtitles,
    timeOffsetSubtitles,
    handleImport,
  };

  return (
    <Container>
      <Header {...props} />
      {!!options.videoUrl && !loading && <Main {...props} />}
      {!!options.videoUrl && !loading && <Footer {...props} />}
    </Container>
  );
}
